import { z } from 'zod/mini'
import type { $ZodType } from 'zod/v4/core'

import { DeviceSchema } from '../models/device'

export function createBlockSchema<
  Type extends string,
  ApiPropsSchema extends $ZodType,
>(type: Type, propsSchema: ApiPropsSchema) {
  return z.object({
    id: z.string(),
    type: z.literal(type),
    hiddenDevices: z.array(DeviceSchema),
    props: propsSchema,
  })
}
